import type {
	SalesEntitiesResponseModel,
	SalesEntityModel,
} from '@/shared/generated'
import type { TreeNodeType } from '@/shared/lib/tree'

import { map, pipe, propOr } from 'lodash/fp'

import { getTree } from '@/shared/lib/tree'

/**
 * Get the sales entities tree based on the sales entities data
 * @param data - The sales entities data
 * @returns The sales entities tree
 */
export const getSalesEntitiesTree: (
	data?: SalesEntitiesResponseModel
) => TreeNodeType[] = pipe([
	propOr([], 'sales_entities'),
	map((item: SalesEntityModel) => ({
		parent: item.parent_id,
		id: item.id,
		name: item.name,
		level: item.sales_level,
	})),
	getTree,
])
